const demsTypes = {
  RESET_DEMS_STATE: 'RESET_DEMS_STATE',
  GENERATE_AI_DEM: {
    REQUEST: 'GENERATE_AI_DEM.REQUEST',
    SUCCESS: 'GENERATE_AI_DEM.SUCCESS',
    FAILURE: 'GENERATE_AI_DEM.FAILURE',
  },
  TOGGLE_DEM_AI_PANEL: 'TOGGLE_DEM_AI_PANEL',
  RESET_DEM_AI_CONVERSATION: 'RESET_DEM_AI_CONVERSATION',
  UNDO_LAST_DEM_AI_DESIGN: 'UNDO_LAST_DEM_AI_DESIGN',
  SYNC_DEMS: {
    REQUEST: 'SYNC_DEMS.REQUEST',
    SUCCESS: 'SYNC_DEMS.SUCCESS',
    FAILURE: 'SYNC_DEMS.FAILURE',
  },
  FETCH_DEM: {
    REQUEST: 'FETCH_DEM.REQUEST',
    SUCCESS: 'FETCH_DEM.SUCCESS',
    FAILURE: 'FETCH_DEM.FAILURE',
  },
  SAVE_DEM: {
    REQUEST: 'SAVE_DEM.REQUEST',
    SUCCESS: 'SAVE_DEM.SUCCESS',
    FAILURE: 'SAVE_DEM.FAILURE',
  },
  ARCHIVE_DEM: {
    REQUEST: 'ARCHIVE_DEM.REQUEST',
    SUCCESS: 'ARCHIVE_DEM.SUCCESS',
    FAILURE: 'ARCHIVE_DEM.FAILURE',
  },
  RESET_DEM_STATS: {
    REQUEST: 'RESET_DEM_STATS.REQUEST',
    SUCCESS: 'RESET_DEM_STATS.SUCCESS',
    FAILURE: 'RESET_DEM_STATS.FAILURE',
  },
};

export default demsTypes;
